import React, { useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import CaseDetailsIcon from "../../../assets/icons/viewer-case-details.svg";
import ReturnIcon from "../../../assets/icons/return-to-worklist.svg";
import Details from "../../slidebox/components/SlideItems/caseDetailsOverlay/Details";

// The purple patient strip at the top of the viewer.
//
// Extracted from viewer-toolbar.js, which used to return this and the icon toolbar as two
// siblings of one Fragment. They now render in different places in the tree: this bar spans
// the full width of .viewer-main-container, while the toolbar lives inside .viewer-pane-left
// so it cannot reach across the block-image panel.
//
// Styling still comes from viewer-container.scss (`.viewer-main-container &
// .patient-details-container`), not from a stylesheet of its own — so this component has to
// stay a descendant of .viewer-main-container or it loses its background, height and padding
// all at once.
//
// The case-details overlay is a three-piece unit — the state below, handleOpenCaseDetails,
// and the <Details> render — and it moved here together. Only the click target ever lived in
// the purple bar; the <Details> consumer used to sit in the toolbar's .other-icons.
const PatientDetailsBar = ({
  when,
  selectedPatientInfo,
  selectedCaseInfo,
  selectedDetails,
}) => {
  const [showCaseDetailsOverlay, setShowCaseDetailsOverlay] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [tabOption, setTabOption] = useState("slides");

  const handleOpenCaseDetails = () => {
    setShowCaseDetailsOverlay(true);
    setShowDetails(true);
  };

  const handleReturnToWorklist = () => {
    window.location.href = "/";
  };

  return (
    <div
      className="patient-details-container"
      data-test="patient-details-container"
    >
      <p className="patient-details">
        <span className="patient" data-test="patient-details">{`${
          selectedPatientInfo.first_name ? selectedPatientInfo.first_name : "—"
        } ${
          selectedPatientInfo.middle_name ? selectedPatientInfo.middle_name : "—"
        } ${selectedPatientInfo.last_name || "—"} (${moment().diff(
          selectedPatientInfo.dob,
          "years"
        ) || "—"}Y/${
          selectedPatientInfo.gender === "Male"
            ? "M"
            : selectedPatientInfo.gender === "Female"
            ? "F"
            : "-"
        }), MRN-${selectedPatientInfo.mrn_number || "—"}`}</span>
        <span
          className="procedure"
          data-test="procedure-details"
        >{` Acc Number: ${selectedCaseInfo.accessionNumber ||
          "—"}, Procedure: ${selectedCaseInfo.procedureName || "—"}`}</span>
      </p>
      <div className="other-icons">
        {when !== "groups" && (
          <img
            src={CaseDetailsIcon}
            width="20px"
            height="20px"
            className="case-details-icon"
            onClick={handleOpenCaseDetails}
            data-for="viewer-toolbar"
            data-place="left"
            data-tip="View case details"
          />
        )}
        <img
          src={ReturnIcon}
          alt="return to worklist"
          className="return-worklist-icon"
          data-for="viewer-toolbar"
          data-place="left"
          data-test="return-to-worklist-icon"
          data-tip="Return to worklist"
          onClick={handleReturnToWorklist}
        />

        {/* Inside .other-icons, not a direct child of the bar. Details renders a
            zero-width <div> wrapper around a position: fixed drawer, which is inert
            in this block container but would become a third flex item of the bar —
            and the bar is justify-content: space-between, so a third item stops the
            icons sitting flush right. showCaseDetailsOverlay is never set back to
            false, so that shift would be permanent for the session. */}
        {showCaseDetailsOverlay && (
          <Details
            showDetails={showDetails}
            setShowDetails={setShowDetails}
            selectedDetails={selectedDetails}
            tabOption={tabOption}
            setTabOption={setTabOption}
          />
        )}
      </div>
    </div>
  );
};

// Only the three entries the bar actually reads. The other five that viewer-toolbar.js maps
// are toolbar-only, and this component dispatches nothing.
const mapStateToProps = (state) => ({
  selectedDetails: state.SlideBox.selectedDetails,
  selectedPatientInfo: state.SlideBox.selectedPatientInfo,
  selectedCaseInfo: state.SlideBox.selectedCaseInfo,
});

export { PatientDetailsBar };
export default connect(mapStateToProps)(PatientDetailsBar);
